export const downloadFromResponse = async (response: Response) => {
  const contentDispositionHeader = response.headers.get('content-disposition');
  let fileName;
  if (contentDispositionHeader) {
    const matches = contentDispositionHeader.match(/"((?:\\.|[^"\\])*)"/);
    fileName = (matches && matches[1]) || undefined;
  }

  downloadBlob(await response.blob(), fileName);
};

export const downloadBlob = (blob: Blob, fileName?: string) => {
  // For IE 10+ only

  if (typeof (window.navigator as any).msSaveBlob === 'function') {
    (window.navigator as any).msSaveBlob(blob, fileName);
  } else {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    if (fileName) {
      a.download = fileName;
    }
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
};

export const sanitizeFilename = (filename: string) => filename.replace(/[^A-z0-9_]/gi, '_').toLowerCase();
